<template>
    <div class="dialog-search-info-customer">
        <div style="display:flex; gap:12px; align-items:center; margin-bottom:12px;">
            <el-row :gutter="12" class="mb-4 w-100">
                <el-col :xs="24" :sm="8" v-if="[6].includes(keyAccount) || [295391, 266029].includes(currentUser.id)">
                    <el-select
                        v-model="form.area_id"
                        placeholder="Khu vực"
                        filterable
                        clearable
                        class="w-100 mt-2"
                        @change="getRegions(); getSales()"
                    >
                        <el-option v-for="item in areas" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                </el-col>

                <el-col :xs="24" :sm="8" v-if="[6].includes(keyAccount) || [295391, 266029].includes(currentUser.id)">
                    <el-select
                        @change="getSales()"
                        v-model="form.branch_id"
                        placeholder="Văn phòng"
                        filterable
                        clearable
                        class="w-100 mt-2"
                    >
                        <el-option
                            v-for="item in branches"
                            :key="item.id"
                            :label="item.name_alias || item.name"
                            :value="item.id"
                        />
                    </el-select>
                </el-col>

                <el-col :xs="24" :sm="8">
                    <el-date-picker
                        class="w-100 mt-2"
                        v-model="form.year"
                        type="year"
                        placeholder="Chọn năm"
                        clearable @change="form.month=''; getSales()">
                    </el-date-picker>
                </el-col>

                <el-col :xs="24" :sm="8">
                    <el-date-picker
                        class="w-100 mt-2"
                        v-model="form.month"
                        type="month"
                        placeholder="Chọn tháng"
                        clearable  @change="form.year=''; getSales()">
                    </el-date-picker>
                </el-col>
            </el-row>
        </div>
        <hr>
        <div v-if="!loading">
            <el-card class="avg-sales" shadow="hover">
                <div slot="header" class="avg-sales__header">
                    <div class="avg-sales__title">
                        <i class="el-icon-data-analysis"></i>
                        <span>  Doanh số trung bình</span>
                    </div>

                    <el-tag size="mini" type="info" effect="plain">
                        {{ filterLabel }}
                    </el-tag>
                </div>

                <div class="avg-sales__list">
                    <div v-for="it in summaryItems" :key="it.key" class="avg-sales__item">
                        <div class="avg-sales__left">
                            <span class="avg-sales__label">{{ it.label }}  </span>

                            <el-tooltip v-if="it.tip && it.value > 0" :content="it.tip" placement="top">
                                <i class="el-icon-question avg-sales__help text-info"></i>
                            </el-tooltip>
                        </div>
                        <div class="avg-sales__value">{{ it.value | formatVND }}</div>
                    </div>

                </div>

                <el-divider content-position="left">Theo cơ chế lương</el-divider>

                <div class="avg-sales__grid">
                    <div v-for="it in mechanismItems" :key="it.key" class="avg-sales__chip">
                        <div class="avg-sales__chipTop">
                            <span class="avg-sales__chipLabel">{{ it.label }}</span>
                            <el-tooltip v-if="it.tip && it.value > 0" :content="it.tip" placement="top">
                                <i class="el-icon-question avg-sales__help"></i>
                            </el-tooltip>
                        </div>
                        <div class="avg-sales__chipValue">{{ it.value | formatPrice }}</div>
                    </div>
                </div>
            </el-card>
        </div>
        <div v-else class="text-center mb-5" style="height: 30vh;">
            <img src="../../../../assets/img/background/bg-loading.svg" alt="Coming Soon" style="max-width: 100%; max-height: 100%;">
            <div>
                <span><i class="el-icon-loading"></i> loading.....</span>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import { GET_SALES_AVERAGE } from "@/core/services/store/user/users.module";
import {BRANCH_LIST} from "../../../../core/services/store/service.module";
import {GET_REGIONS_BY_USER} from "../../../../core/services/store/customer/customer.module";

export default {
    name: 'AverageSales',
    props: {
        is_show: { type: Boolean, default: () => false },
    },
    data () {
        return {
            form: {
                mechanism: '',
                month: new Date(),
                year: '',
            },
            tableData: [],
            branches: [],
            areas: [],
            loading: false,
            paging: {
                current_page: 1,
                per_page: 25,
                total: 0,
            },
            stats: {
            team_avg: 0,
            leader_avg: 0,
            mechanism_avg: {
                soft: 0,
                hard: 0,
                hard_rank: 0,
                hard_fixed: 0,
                part_time: 0,
            },
        }
        }
    },
    watch: {
        is_show: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.getSales();
                }
            },
        },
    },

    mounted() {
        this.getRegions()
        this.getBranch()
    },
    methods: {
        getSales() {
            this.loading = true;

            let dateRange = [];

            if (this.form.month || this.form.year) {
                const date = this.$moment(this.form.month || this.form.year);
                const unit = this.form.month ? 'month' : 'year';

                dateRange = [
                    date.clone().startOf(unit).format('YYYY-MM-DD'),
                    date.clone().endOf(unit).format('YYYY-MM-DD')
                ];
            }

            const payload = {
                mechanism: this.form.mechanism,
                branch_id: this.form.branch_id,
                area_id: this.form.area_id,
                date_range: dateRange,
            };

            this.$store.dispatch(GET_SALES_AVERAGE, payload)
                .then((response) => {
                    const data = response?.data?.data ?? response?.data ?? {}
                    this.stats.team_avg = data.all_team ?? []
                    this.stats.leader_avg = data.leader_summary ?? []
                    this.stats.staff_avg = data.staff_summary ?? []
                    this.stats.mechanism_avg = data.staff_average_by_mechanism ?? []
                    this.loading = false
                })
                .finally(() => { this.loading = false })
        },

        getBranch () {
            const payload = { area_id: this.form.area_id }
            this.$store.dispatch(BRANCH_LIST, payload).then((response) => {
                this.branches = response.data
            })
        },

        getRegions () {
            const payload = { all: this.keyAccount === 7 ? 1 : 0 }
            this.$store.dispatch(GET_REGIONS_BY_USER, payload).then((response) => {
                this.areas = response.data
            })
        },
    },

    computed: {
        ...mapGetters(["currentUser", "keyAccount"]),

        filterLabel() {
            if (this.form.year) return `Năm ${this.$moment(this.form.year).format('YYYY')}`
            if (this.form.month) return this.$moment(this.form.month).format('MM/YYYY')
            return 'Mặc định'
        },

        summaryItems() {
            return [
                {
                    key: 'team',
                    label: 'Doanh số trung bình team',
                    value: this.stats.team_avg.average_amount,
                    tip: this.stats.team_avg
                        ? `${Number(this.stats.team_avg.total_amount || 0).toLocaleString('vi-VN')} / ${this.stats.team_avg.total_user}`
                        : '',
                },
                {
                    key: 'leader',
                    label: 'Doanh số trung bình sales leader',
                    value: this.stats.leader_avg.average_amount,
                    tip: this.stats.leader_avg
                        ? `${Number(this.stats.leader_avg.total_amount || 0).toLocaleString('vi-VN')} / ${this.stats.leader_avg.total_user}`
                        : '',
                },

                {
                    key: 'staff',
                    label: 'Doanh số trung bình nhân viên',
                    value: this.stats.staff_avg.average_amount,
                    tip: this.stats.staff_avg
                        ? `${Number(this.stats.staff_avg.total_amount || 0).toLocaleString('vi-VN')} / ${this.stats.staff_avg.total_user}`
                        : '',
                },
            ]
        },

        mechanismItems() {
            const arr = Array.isArray(this.stats.mechanism_avg) ? this.stats.mechanism_avg : []

            return arr.map(it => {
                const id = Number(it.salary_mechanism_id)

                return {
                    key: String(id),
                    label: it.salary_mechanism || `Cơ chế ${id}`,
                    value: Number(it.average_amount || 0),
                    tip: it
                        ? `${Number(it.total_amount || 0).toLocaleString('vi-VN')} / ${it.total_user}`
                        : '',
                    meta: {
                        total_user: Number(it.total_user || 0),
                        total_amount: Number(it.total_amount || 0),
                    }
                }
            })
        },
    },
    }
</script>

<style scoped>
.avg-sales {
    border-radius: 12px;
}

.avg-sales__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}

.avg-sales__title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 700;
}

.avg-sales__list {
    display: grid;
    gap: 10px;
}

.avg-sales__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 12px;
    border-radius: 10px;
    background: #f7f9fc;
}

.avg-sales__left {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
}

.avg-sales__label {
    font-weight: 600;
    color: #2c3e50;
}

.avg-sales__help {
    color: #409eff;
    cursor: pointer;
}

.avg-sales__value {
    font-weight: 800;
    letter-spacing: .2px;
    font-variant-numeric: tabular-nums;
    color: #111827;
}

.avg-sales__grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
}

.avg-sales__chip {
    padding: 12px;
    border: 1px solid #ebeef5;
    border-radius: 12px;
    background: #fff;
}

.avg-sales__chipTop {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 6px;
}

.avg-sales__chipLabel {
    font-weight: 600;
    color: #374151;
}

.avg-sales__chipValue {
    font-weight: 800;
    font-variant-numeric: tabular-nums;
}

@media (max-width: 992px) {
    .avg-sales__grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}

@media (max-width: 576px) {
    .avg-sales__grid { grid-template-columns: 1fr; }
    .avg-sales__item { align-items: flex-start; flex-direction: column; gap: 6px; }
    .avg-sales__value { width: 100%; text-align: left; }
}
</style>
